export const SET_ERROR = "setError";
export const CLEAR_ERROR = "clearError";
export const SET_EMAIL = "setEmail";
export const CLEAR_EMAIL = "clearEmail";
export const SET_PASSWORD = "setPassword";
export const SET_CONFIRM_PASSWORD = "setConfirmPassword";
export const CLEAR_PASSWORD = "clearPassword";
export const CLEAR_CONFIRM_PASSWORD = "clearConfirmPassword";
export const SET_CURRENT_PASSWORD = "setCurrentPassword";
export const CLEAR_CURRENT_PASSWORD = "clearCurrentPassword";
